var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionareSubmitted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20538",
    "data-name": "\\uADF8\\uB8F9 20538",
    transform: "translate(-164.437 -268.437)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8439",
    "data-name": "\\uC0AC\\uAC01\\uD615 8439",
    width: 80,
    height: 80,
    transform: "translate(164.437 268.437)",
    fill: "red",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20537",
    "data-name": "\\uADF8\\uB8F9 20537",
    transform: "translate(173.705 279.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_8438",
    "data-name": "\\uC0AC\\uAC01\\uD615 8438",
    transform: "translate(11.731 2.114)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0H34a4,4,0,0,1,4,4V43a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,1H34a3,3,0,0,1,3,3V42a0,0,0,0,1,0,0H1a0,0,0,0,1,0,0V4A3,3,0,0,1,4,1Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_8436",
    "data-name": "\\uC0AC\\uAC01\\uD615 8436",
    transform: "translate(7.731 7.114)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0H42a4,4,0,0,1,4,4V40a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,1H42a3,3,0,0,1,3,3V39a0,0,0,0,1,0,0H1a0,0,0,0,1,0,0V4A3,3,0,0,1,4,1Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_8437",
    "data-name": "\\uC0AC\\uAC01\\uD615 8437",
    transform: "translate(-0.269 44.114)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 60,
    height: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2512",
    "data-name": "\\uD328\\uC2A4 2512",
    d: "M7015.936-4059.828l8.52-8.479",
    transform: "translate(-7015.637 4104.424)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2514",
    "data-name": "\\uD328\\uC2A4 2514",
    d: "M7024.456-4059.828l-8.52-8.479",
    transform: "translate(-6963.291 4104.424)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2515",
    "data-name": "\\uD328\\uC2A4 2515",
    d: "M19.138,19.4H37.617",
    transform: "translate(-1)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2517",
    "data-name": "\\uD328\\uC2A4 2517",
    d: "M19.138,19.4H42.552",
    transform: "translate(-1 15.424)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2516",
    "data-name": "\\uD328\\uC2A4 2516",
    d: "M19.138,19.4H33.765",
    transform: "translate(-1 7.712)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_333",
    "data-name": "\\uD0C0\\uC6D0 333",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(29.731 -4.886)",
    fill: "#ef6156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2511",
    "data-name": "\\uD328\\uC2A4 2511",
    d: "M7029.541-4076.08l5.345,5.346,9.066-9.066",
    transform: "translate(-6990.22 4086.914)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionareSubmitted);
export default __webpack_public_path__ + "static/media/questionareSubmitted.f518410a9bbd22c42d97d140e31a4fe6.svg";
export { ForwardRef as ReactComponent };